import { DocumentData } from "@angular/fire/firestore";

export class OrderSummary {
  public readonly paymentType: string;
  public readonly price: number;
  public readonly purchasedAt: Date;
  public readonly redeemedAt: Date;
  public readonly serviceFee: number;
  public readonly subtotal: number;
  public readonly tip: number;
  public readonly total: number;
  public readonly units: number;
  constructor(data: DocumentData) {
    this.paymentType = data.paymentType;
    this.price = data.price / 100;
    this.purchasedAt = (data.purchasedAt as firebase.firestore.Timestamp).toDate();
    this.redeemedAt =
      data.redeemedAt == null
        ? null
        : (data.redeemedAt as firebase.firestore.Timestamp).toDate();
    this.serviceFee = data.serviceFee == null ? null : data.serviceFee / 100;
    this.subtotal = data.subtotal / 100;
    this.tip = data.tip == null ? null : data.tip / 100;
    this.total = data.total / 100;
    this.units = data.units;
  }
}
